<template>
  <div>
    <DormList :dorms="dorms" v-if="dorms"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import DormList from '@/components/DormList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'
export default {
  name: 'UniversityFacultyGender',
  components: {
    DormList,
    FixedPopup
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/' + this.$route.params.slug + '-yakin-ogrenci-yurtlari/' }
      ]
    }
  },
  data () {
    return {
      dorms: null,
      popupDorms: null,
      errors: [],
      gender: '',
      typeID: null,
      faculty: null
    }
  },
  methods: {
    checkGender () {
      if (this.$route.params.type === 'erkek') {
        this.gender = 'Erkek'
        this.typeID = 1
      } else if (this.$route.params.type === 'kiz') {
        this.gender = 'Kız'
        this.typeID = 2
      }
    },
    getDorms () {
      this.checkGender()
      const self = this

      axios.get(`/site/universities/dorms/${this.$route.params.slug}?faculty=${this.$route.params.faculty}&dorm_type=${self.typeID}`)
        .then(response => {
          self.dorms = response.data.data.data
          self.faculty = response.data.faculty
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  computed: {
    pageTitle () {
      let title = ''
      if (this.faculty) {
        if (this.typeID === 1) title = this.faculty.male_title
        else if (this.typeID === 2) title = this.faculty.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.faculty) {
        if (this.typeID === 1) title = this.faculty.male_description
        else if (this.typeID === 2) title = this.faculty.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.faculty) {
        if (this.typeID === 1) title = this.faculty.male_keywords
        else if (this.typeID === 2) title = this.faculty.female_keywords
      }
      return title
    }
  },
  created () {
    this.getDorms()
  },
  watch: {
    $route () {
      this.getDorms()
    }
  }
}
</script>

<style scoped>

</style>
